var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSharePoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.222 7.16H16.888C16.903 7.07 16.916 6.978 16.916 6.883V4.57C16.916 3.59 16.119 2.793 15.138 2.793H1.5V1.358C1.5 0.944002 1.164 0.608002 0.75 0.608002C0.336 0.608002 0 0.944002 0 1.358V18.83C0 19.245 0.336 19.58 0.75 19.58C1.164 19.58 1.5 19.245 1.5 18.83V17.396H12.056C13.036 17.396 13.834 16.599 13.834 15.619V13.306C13.834 13.211 13.82 13.119 13.806 13.028H18.223C19.203 13.028 20.001 12.23 20.001 11.25V8.94C20.001 7.957 19.204 7.16 18.223 7.16H18.222ZM15.14 4.293C15.292 4.293 15.417 4.417 15.417 4.57V6.88C15.417 7.034 15.292 7.16 15.139 7.16H1.5V4.29H15.14V4.293ZM12.333 13.307V15.619C12.333 15.772 12.208 15.896 12.055 15.896H1.5V13.028H12.056C12.209 13.028 12.333 13.154 12.333 13.308V13.307ZM18.5 11.25C18.5 11.403 18.375 11.527 18.222 11.527H1.5V8.66H18.222C18.375 8.66 18.5 8.784 18.5 8.937V11.25Z",
    fill: "#1DA1F2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharePoll);
export default __webpack_public_path__ + "static/media/sharePoll.f48490b47364855360a5bf3e2c97ef2a.svg";
export { ForwardRef as ReactComponent };